import { render } from "./NotFoundView.vue?vue&type=template&id=35337b89"
import script from "./NotFoundView.vue?vue&type=script&lang=js"
export * from "./NotFoundView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__